export enum BrandClickOrigin {
  EmailsTemplateStep = 'emails-template-step',
  ImportClientsConfirmation = 'import-clients-confirmation',
  ImportClientsStep = 'import-clients-step',
  Network = 'network-page',
  BulkActions = 'bulk-actions',
  ContactProfileDrawer = 'contact-profile-drawer',
  Orders = 'orders',
  PreparedOrder = 'prepared-orders',
  NetworkBanner = 'network-banner',
  NetworkTable = 'network-table',
  DiscountCreation = 'discount-creation',
  DiscountRemoval = 'discount-removal',
  ContactDeletion = 'contact-deletion',
  HolidayMode = 'holiday-mode-page',
  CampaignPage = 'campaign-page',
  CampaignBanner = 'campaign-banner',
  CampaignDraftDeletionPopup = 'draft-deletion-popup',
  ContactsActionsBannerMyNetwork = 'contacts-actions-banner-my-network',
  ContactsActionsBannerCreateCampaign = 'contacts-actions-banner-create-campaign',
  CartsToConvert = 'carts-to-convert',
  DiscountManagement = 'discount-management',
}

export enum BrandClickAction {
  BrandViewOrders = 'view-orders',
  BrandCantInvite = 'brand_cant_invite',
  BrandClosePendingInvitationReminder = 'brand_close_pending_invitation_reminder',
  BrandDoItLater = 'brand_do_it_later',
  BrandGoToInviteViaPendingInvitationReminder = 'brand_go_to_invite_via_pending_invitation_reminder',
  BrandSaveAndSendInvitation = 'brand_save_and_send_invitation',
  BrandSaveList = 'brand_save_list',
  BrandStartInvitation = 'brand_start_invitation',
  BrandStartInviteMyContacts = 'brand_start_invite_my_contacts',
  BrandExportContacts = 'export',
  BrandSendCampaign = 'send-campaign',
  BrandAddDiscount = 'add-discount',
  BrandAddDiscountBulk = 'bulk-add-discount',
  BrandDeleteContactsBulk = 'bulk-delete-contacts',
  BrandOpenContactProfileDrawer = 'open-contact-profile-drawer',
  BrandCloseContactProfileDrawer = 'close-contact-profile-drawer',
  BrandDeleteContactsBulkSave = 'save-bulk-delete-contact',
  BrandCreateCampaignForContact = 'create-campaign-for-contact',
  BrandRemoveDiscount = 'remove-discount',
  BrandDeleteContact = 'delete-contact',
  BrandGoToCreateOrder = 'brand-go-to-create-order',
  BrandNewOrderQuantityNotMultipleOfUnitMultiplier = 'brand-new-order-quantity-not-multiple-of-unit-multiplier',
  BrandCopyPreparedOrderLink = 'brand-copy-prepare-order-link',
  BrandOpenContactsFilter = 'open-filter',
  BrandConfirmRemoveDiscount = 'save_remove_discount',
  BrandConfirmRemoveDiscountBulk = 'save-bulk-remove-discount',
  BrandConfirmAddDiscount = 'save_discount',
  BrandConfirmDeleteContact = 'save_delete_contact',
  BrandApplyFilters = 'apply_filters',
  BrandApplyFilter = 'apply_filter',
  BrandApplySegment = 'apply_segment',
  BrandSetHolidayMode = 'set-holiday-mode',
  BrandUnsetHolidayMode = 'unset-holiday-mode',
  BrandCopyLiftCode = 'copy-liftcode',
  BrandRegisterWebinar = 'register-webinar',
  BrandCampaignsDraftSave = 'save-delete-draft',
  BrandCampaignsDraftCancel = 'cancel-delete-draft',
  BrandCampaignsDraftDelete = 'delete-draft-campaign',
  BrandDiscountsStartNewDiscount = 'start-new-discount',
  BrandDiscountsDeleteNewDiscount = 'delete-new-discount',
  BrandDiscountsSaveNewDiscount = 'save-new-discount',
  BrandOrderHistoryTabClick = 'click-order-history-tab',
  BrandExpandOrderCard = 'expand-order-card',
  BrandClickOrderId = 'click-orderid',
  BrandIncludeAllUninvited = 'include-all-uninvited',
  BrandsyncWithKlaviyo = 'sync-with-klaviyo',
}
